<zag-accordion>
  @for (section of sections(); track section.id) {
    @if (section.wrapInAccordion !== false) {
      <zag-accordion-item
        [title]="section.titleKey | translate"
        [icon]="section.icon"
        [badge]="getBadge(section.id)"
        [expanded]="section.id === initialExpandedId"
      >
        <ng-container *ngComponentOutlet="section.component" />
      </zag-accordion-item>
    } @else {
      <ng-container *ngComponentOutlet="section.component" />
    }
  }
</zag-accordion>
